import React from 'react';
import jackBg from '../../assets/daily-jack.png';
import wingBg from '../../assets/daily-wing.png';
import clockIcon from '../../assets/daily-clock.webp';
import {Image} from 'antd-mobile';
import {cn} from '@utils';
import CountUp from 'react-countup';

const textStyle =
  'bg-gold-text text-[2rem] bg-clip-text text-transparent text-center font-black';

interface JackpotProps {
  countdown: string;
  jackpot?: number;
  loading?: boolean;
  showCountdown?: boolean; // 控制是否显示倒计时UI
}

export default function Jackpot({
  countdown,
  jackpot = 0,
  showCountdown = true,
  loading,
}: JackpotProps) {
  return (
    <>
      <div className="w-full relative h-[9.5rem] pointer-events-none">
        <div className="absolute -top-[5rem] w-full h-[12.625rem]">
          <div
            className="w-full h-[15.34375rem] z-10 absolute left-1/2 -translate-x-1/2 top-0 bg-full"
            style={{
              backgroundImage: `url(${jackBg})`,
            }}>
            <div
              className={cn(
                'absolute left-1/2 -translate-x-1/2 bottom-6 font-black text-[2rem] flex items-center',
                textStyle,
                'daily-counter',
              )}>
              <span>₹</span>
              <CountUp end={loading ? 0 : jackpot} duration={3} separator="," />
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${wingBg})`,
            }}
            className="w-full h-[15.34375rem] z-1 absolute left-1/2 -translate-x-1/2 -top-1 bg-full"></div>
        </div>
      </div>
      {showCountdown && (
        <div className="flex items-center gap-1 justify-center">
          <Image src={clockIcon} className="size-3"></Image>
          <span
            className="text-xs font-semibold capitalize"
            style={{
              color: '#FFEAA7',
              textShadow: `
                      -1px -1px 0 #644100,
                      1px -1px 0 #644100,
                      -1px 1px 0 #644100,
                      1px 1px 0 #644100
                    `,
            }}>
            Event Countdown {countdown}
          </span>
        </div>
      )}
    </>
  );
}
